import { PremiumBadge } from './PremiumBadge';

export default PremiumBadge;
export { PremiumIcon } from './PremiumIcon';
